import { CaretRight, type IconProps } from "@phosphor-icons/react";

export function ChevronRightIcon(props: IconProps) {
  return <CaretRight size={24} weight="regular" {...props} />;
}
